'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lapp_api_ClientOrganizationInfo(orgInfo, logo, verified, createdAt) {
  this.rY = null;
  this.Kl = null;
  this.Km = false;
  this.Xe = null;
  this.rY = orgInfo;
  this.Kl = logo;
  this.Km = verified;
  this.Xe = createdAt;
}
export { $c_Lapp_api_ClientOrganizationInfo as $c_Lapp_api_ClientOrganizationInfo };
$p = $c_Lapp_api_ClientOrganizationInfo.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lapp_api_ClientOrganizationInfo;
/** @constructor */
function $h_Lapp_api_ClientOrganizationInfo() {
}
export { $h_Lapp_api_ClientOrganizationInfo as $h_Lapp_api_ClientOrganizationInfo };
$h_Lapp_api_ClientOrganizationInfo.prototype = $p;
$p.z = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$p.p = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$().P(this, (-889275714), false);
});
$p.f = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lapp_api_ClientOrganizationInfo)) {
    var x = this.rY;
    var x$2 = x$0.rY;
    if (((x === null) ? (x$2 === null) : x.f(x$2))) {
      var x$3 = this.Kl;
      var x$4 = x$0.Kl;
      var $x_1 = ((x$3 === null) ? (x$4 === null) : x$3.f(x$4));
    } else {
      var $x_1 = false;
    }
    if (($x_1 && (this.Km === x$0.Km))) {
      var x$5 = this.Xe;
      var x$6 = x$0.Xe;
      return ((x$5 === null) ? (x$6 === null) : x$5.f(x$6));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.n = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().V(this);
});
$p.s = (function() {
  return 4;
});
$p.t = (function() {
  return "ClientOrganizationInfo";
});
$p.e = (function(n) {
  switch (n) {
    case 0: {
      return this.rY;
      break;
    }
    case 1: {
      return this.Kl;
      break;
    }
    case 2: {
      return this.Km;
      break;
    }
    case 3: {
      return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lframework_data_FrameworkDateTime(this.Xe);
      break;
    }
    default: {
      throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$p.u = (function(n) {
  switch (n) {
    case 0: {
      return "orgInfo";
      break;
    }
    case 1: {
      return "logo";
      break;
    }
    case 2: {
      return "verified";
      break;
    }
    case 3: {
      return "createdAt";
      break;
    }
    default: {
      throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
function $isArrayOf_Lapp_api_ClientOrganizationInfo(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.ig)));
}
export { $isArrayOf_Lapp_api_ClientOrganizationInfo as $isArrayOf_Lapp_api_ClientOrganizationInfo };
var $d_Lapp_api_ClientOrganizationInfo = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lapp_api_ClientOrganizationInfo, "app.api.ClientOrganizationInfo", ({
  ig: 1,
  b: 1,
  c: 1,
  a: 1
}));
export { $d_Lapp_api_ClientOrganizationInfo as $d_Lapp_api_ClientOrganizationInfo };
//# sourceMappingURL=app.api.-Client-Organization-Info.js.map
